import api from "./axios";

export const fetchDailyNotebookEntries = (projectId, { from, to, sprintId } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  if (sprintId !== undefined && sprintId !== null && sprintId !== "") {
    params.sprintId = sprintId;
  }
  return api.get(`/projects/${projectId}/daily-notebook`, { params }).then((r) => r.data);
};

export const createDailyNotebookEntry = (projectId, payload) =>
  api.post(`/projects/${projectId}/daily-notebook`, payload).then((r) => r.data);

export const updateDailyNotebookEntry = (projectId, entryId, payload) =>
  api.patch(`/projects/${projectId}/daily-notebook/${entryId}`, payload).then((r) => r.data);

export const toggleDailyNotebookReaction = (projectId, entryId, emoji) =>
  api
    .post(`/projects/${projectId}/daily-notebook/${entryId}/reactions`, { emoji })
    .then((r) => r.data);

export const deleteDailyNotebookEntry = (projectId, entryId, { deleteIssues = true } = {}) =>
  api
    .delete(`/projects/${projectId}/daily-notebook/${entryId}`, {
      params: { deleteIssues: deleteIssues ? "true" : "false" },
    })
    .then((r) => r.data);
